import newsapi from '@/api/news'
import { getStore } from '@/utils/common'

const news = {
  state: {
    total: 0,
    rows: [],
    row: {},
    years: [],
    permission: {},
    errcode: '',
    viewMode: getStore().viewMode,
    isLoading: false,
    items: []
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_YEARS: (state, years) => {
      state.years = years
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = permission
    },
    SET_ERRCODE: (state, errcode) => {
      state.errcode = errcode
    },
    SET_LOADING_STATUS: (state, status) => {
      state.isLoading = status
    },
    SET_ITEMS: (state, items) => {
      state.items = items
    }
  },
  actions: {
    // 权限
    SharePermission({ commit }, params) {
      commit('SET_PERMISSION', params)
    },
    // 设置loading状态
    SetLoadingStatus({ commit }, status) {
      commit('SET_LOADING_STATUS', status)
    },
    // 获取新闻
    GetNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getNews(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取热点新闻
    GetHotNews({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getHotNews(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取新闻详情
    GetNewsDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getNewsDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          commit('SET_ERRCODE', response.ErrorCode)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取新闻摘要
    GetNewsSummary({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getNewsSummary(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取汇率信息
    GetExchangeRate({ commit }, target) {
      return new Promise((resolve, reject) => {
        newsapi.getExchangeRate(target).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取行情指标
    GetFrontMarketIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontMarketIndex(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加用户成交价
    AddUserFinalPrice({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.addUserFinalPrice(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取行情周报
    GetFrontMarketReport({ commit }, token) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontMarketReport(token).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 获取行情周报详情
    GetFrontMarketReportDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontMarketReportDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row || response.Data.PriceRow)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 获取行情数据
    GetUserMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getUserMarketPriceData(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // 添加行情
    AddFrontUserFinalPrice({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.addFrontUserFinalPrice(params).then(() => {
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    // 获取当前用户行情
    GetCurrentUserMarketPriceData({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getCurrentUserMarketPriceData(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 获取进口量数据
    GetImportLevel({ commit }) {
      return new Promise((resolve, reject) => {
        newsapi.getImportLevel().then((response) => {
          commit('SET_ROW', response.Data.Dicts)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 查询行情周报权限
    GetFrontReportPermission({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontReportPermission(params).then((response) => {
          commit('SET_ROW', response.Data.PermissionInfo)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 检查用户是否填写过行情
    CheckFrontUserFinalPriceState({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.checkFrontUserFinalPriceState(params).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    GetFrontReportEnPermission({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontReportEnPermission(params).then((response) => {
          commit('SET_ROW', response.Data.PermissionInfo)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 获取行情指标(多个国家)
    GetFrontMarketMultiIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontMarketMultiIndex(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询行情数据
    GetPriceDataList({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getPriceDataList(params).then(response => {
          commit('SET_ROW', response.Data.Dict)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询行情有效日期
    GetPriceVaildDate({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getPriceVaildDate(params).then(response => {
          commit('SET_ROWS', response.Data.List)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 行情试用
    MarketPriceTrial({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.marketPriceTrial(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetFrontPriceDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontPriceDictionary(params).then((response) => {
          commit('SET_ITEMS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAppNewsDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getAppNewsDetail(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSimilarArticle({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getSimilarArticle(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPriceDataIndex({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getPriceDataIndex(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAppNewsAnalysis({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getAppNewsAnalysis(params).then((response) => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_YEARS', response.Data.Years)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询周市权限
    GetFrontNewsPermission({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontNewsPermission(params).then((response) => {
          commit('SET_ROW', response.Data.PermissionInfo)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 获取周市详情
    GetFrontMarketNewsDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        newsapi.getFrontMarketNewsDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row || response.Data.PriceRow)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    }
  }
}
export default news



// WEBPACK FOOTER //
// ./src/store/modules/news.js